import { defaultFilter } from 'pages/today/constants';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';
import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
} from 'shared/types/filter-document';
import {
  GroupByMode,
  TaskGroupBy,
  TodayGroupBy,
} from 'shared/types/sorting-mode';
import { TaskType } from 'shared/types/task-base';

export const useTodayFilterDocument = (): FilterDocument => {
  const user = useUser();
  const today = useToday();

  return useMemo(() => {
    const baseDocument = defaultFilter(today);

    // todo: activate when iOS supports the new filter options
    // if (user?.settings?.filters?.today) {
    //   const savedFilters = user.settings.filters.today.filters ?? {};
    //   let typeLimit = savedFilters[FilterOptionKeys.Type];
    //   const defaultTypes = Object.values(TaskType);
    //
    //   if (user?.settings?.todayHideHabits) {
    //     const currentIncludes = typeLimit?.include ?? defaultTypes;
    //
    //     typeLimit = {
    //       ...typeLimit,
    //       include: currentIncludes.filter((t) => t !== TaskType.Habit),
    //     };
    //   }
    //   if (
    //     typeLimit?.include &&
    //     !typeLimit.include.includes(TaskType.Habit) &&
    //     !user?.settings?.todayHideHabits
    //   ) {
    //     typeLimit = {
    //       ...typeLimit,
    //       include: [...typeLimit.include, TaskType.Habit],
    //     };
    //   }
    //
    //   return {
    //     ...baseDocument,
    //     ...user.settings.filters.today,
    //     [DocumentOrganizationKeys.GroupByMode]:
    //       user.settings.filters.today[DocumentOrganizationKeys.GroupByMode] ??
    //       (user?.settings?.todayGroupBy
    //         ? user.settings.todayGroupBy === TodayGroupBy.None
    //           ? GroupByMode.Deadline
    //           : (user.settings.todayGroupBy as unknown as TaskGroupBy)
    //         : undefined) ??
    //       baseDocument[DocumentOrganizationKeys.GroupByMode],
    //     [DocumentOrganizationKeys.SortingMode]:
    //       user.settings.filters.today[DocumentOrganizationKeys.SortingMode] ??
    //       user?.settings?.todoSortingMode ??
    //       baseDocument[DocumentOrganizationKeys.SortingMode],
    //     [DocumentOrganizationKeys.Filters]: {
    //       ...baseDocument[DocumentOrganizationKeys.Filters],
    //       ...savedFilters,
    //       [FilterOptionKeys.Type]: typeLimit,
    //     },
    //     [DocumentOrganizationKeys.Or]:
    //       baseDocument[DocumentOrganizationKeys.Or],
    //   };
    // }

    // fallback on old settings
    return {
      ...baseDocument,
      [DocumentOrganizationKeys.GroupByMode]:
        (user?.settings?.todayGroupBy
          ? user.settings.todayGroupBy === TodayGroupBy.None
            ? GroupByMode.Deadline
            : (user.settings.todayGroupBy as unknown as TaskGroupBy)
          : undefined) ?? baseDocument[DocumentOrganizationKeys.GroupByMode],
      [DocumentOrganizationKeys.SortingMode]:
        user?.settings?.todoSortingMode ??
        baseDocument[DocumentOrganizationKeys.SortingMode],

      [DocumentOrganizationKeys.Filters]: {
        ...baseDocument[DocumentOrganizationKeys.Filters],
        [FilterOptionKeys.Type]: user?.settings?.todayHideHabits
          ? {
              include: Object.values(TaskType).filter(
                (type) => type !== TaskType.Habit,
              ),
            }
          : baseDocument[DocumentOrganizationKeys.Filters][
              FilterOptionKeys.Type
            ],
        [FilterOptionKeys.Tag]:
          user?.settings?.todayFilterByTags?.length ||
          user?.settings?.filters?.today?.[DocumentOrganizationKeys.Filters]?.[
            FilterOptionKeys.Tag
          ]?.noTag
            ? {
                include: user?.settings?.todayFilterByTags?.length
                  ? user.settings.todayFilterByTags
                  : null,
                noTag:
                  user?.settings?.filters?.today?.[
                    DocumentOrganizationKeys.Filters
                  ]?.[FilterOptionKeys.Tag]?.noTag ?? null,
              }
            : baseDocument[DocumentOrganizationKeys.Filters]?.[
                FilterOptionKeys.Tag
              ],
      },
      [DocumentOrganizationKeys.Or]: baseDocument[DocumentOrganizationKeys.Or],
      [DocumentOrganizationKeys.CollapsedSections]:
        user?.settings?.filters?.today?.[
          DocumentOrganizationKeys.CollapsedSections
        ],
    };
  }, [
    today,
    user?.settings?.todayGroupBy,
    user?.settings?.todoSortingMode,
    user?.settings?.todayHideHabits,
    user?.settings?.todayFilterByTags,
    user?.settings?.filters?.today,
  ]);
};
